<template>
  <div class="container">
    <p>
      文献AI服务平台是专为读者提供的个性化科研工作台，提供从文献检索-文献解析-文献管理的科研多场景服务，平台提供学科资讯和技术概念分析获取最新学科资讯，掌握研究方向。提供文献解析和文献综述从单篇文章到多篇文章，提供AI工具帮助读者提高阅读效率，同时提供文献管理工具，统一管理相关文献，文献支持本地上传。支持创建文件夹，分组分类管理。用户可自行对文章添加标签，支持多种修改操作。提供引文工具，统一汇总参考文献，支持多种引文格式导出。
    </p>
    <p>
      注意事项：文献服务平台为读者个人平台，需在ip内注册个人账号才能享受该服务，获得专属的个人空间。
    </p>
    <p>
      1.学科资讯：个性化选择所学学科，关注前沿资讯，了解最新学术报告和学术动态及成果。
    </p>
    <img src="../../assets/images/newhelp/help25.png" alt="" />
    <p>
      2.概念趋势分析：个性化选择相关技术概念，了解所关注概念的发展趋势，相关概念的作者及作者的H指数，论文数，引用量；相关机构及机构的论文数量、引用量；相关期刊及期刊里面的文献资源。
    </p>
    <img src="../../assets/images/newhelp/help26.png" alt="" />
    <p>
      3.文献解析：数据库中的文献资源或个人上传的文献，提供文献解析功能，提取文献内容的研究要点、方法、实现过程等内容，使读者更快理解文献内容，节省阅读时间，提高研究效率！从导入文献到生成大约时间为5-10分钟，结果生成在文献解析结果里查看
    </p>
    <img src="../../assets/images/newhelp/help27.png" alt="" />
    <img src="../../assets/images/newhelp/help28.png" alt="" />
    <p>
      4.文献综述：选择多篇文献可自动生成文献综述，为读者研究提供背景、理论支持和研究方法，帮助研究者避免重复研究，发现研究缺口，并为学位论文的选题和研究提供有力的支持。同时，它还有助于预测研究趋势，寻求新的研究突破点，从而推动学术研究和科研工作的进步，对其做出综合性介绍和阐述并以报告的形式展示。读者还可以通过多轮问答的形式，深入进行知识学习，深层理解。
    </p>
    <img src="../../assets/images/newhelp/help29.png" alt="" />
    <img src="../../assets/images/newhelp/help30.png" alt="" />
    <p>
      5.AI搜索：根据读者输入的内容，利用DeepSeek大模型快速理解并进行分析，提供相关度最高的文献供读者进行查阅。
    </p>
    <img src="../../assets/images/newhelp/help31.png" alt="" />
    <img src="../../assets/images/newhelp/help32.png" alt="" />
    <p>
      6.文献资源个性化管理：可上传或导入自己下载的文献资源，用户可自建多个文件夹将文献分类存放于各个文件夹中。并对文献资源进行个性化打标签分类管理。针对上传的文献进行文献基本信息的编辑管理、在线阅读、在线解析、在线翻译、下载、删除等功能。
    </p>
    <img src="../../assets/images/newhelp/help33.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
